import type {
  EmailMessage,
  EmailMessageInput,
  EmailMessageStatus,
} from "@sales-ops-amplify/shared";
import { apiDelete, apiGet, apiPatch, apiPost } from "./client";

export function listEmails(params?: {
  status?: EmailMessageStatus;
  leadId?: string;
  sequenceId?: string;
  opportunityId?: string;
  mailboxId?: string;
  fromEmail?: string;
  dateFrom?: string;
  dateTo?: string;
  notSentReason?: string;
  opened?: boolean;
  minOpens?: number;
  listId?: string;
  q?: string;
  limit?: number;
}): Promise<{ emails: EmailMessage[] }> {
  return apiGet(
    "/api/emails",
    params as Record<string, string | number | boolean | undefined>,
  );
}

export function getEmailStats(): Promise<{
  scheduled: number;
  sent: number;
  replied: number;
  failed: number;
  draft: number;
  opened?: number;
  clicked?: number;
}> {
  return apiGet("/api/emails/stats");
}

export function getEmailThread(
  emailMessageId: string,
): Promise<{ message: EmailMessage; thread: EmailMessage[] }> {
  return apiGet(`/api/emails/${emailMessageId}`);
}

export function createEmailDraft(
  input: EmailMessageInput,
): Promise<{ email: EmailMessage }> {
  return apiPost("/api/emails", input);
}

export function updateEmailDraft(
  emailMessageId: string,
  fields: Partial<EmailMessageInput>,
): Promise<{ email: EmailMessage }> {
  return apiPatch(`/api/emails/${emailMessageId}`, fields);
}

export function deleteEmail(
  emailMessageId: string,
): Promise<{ deleted: boolean }> {
  return apiDelete(`/api/emails/${emailMessageId}`);
}

export function sendEmail(
  emailMessageId: string,
): Promise<{ email: EmailMessage }> {
  return apiPost(`/api/emails/${emailMessageId}/send`, {});
}

export function replyEmail(
  emailMessageId: string,
  body: { bodyHtml?: string; bodyText?: string; scheduledAt?: string },
): Promise<{ email: EmailMessage }> {
  return apiPost(`/api/emails/${emailMessageId}/reply`, body);
}

export function syncEmails(params?: {
  opportunityId?: string;
}): Promise<{ created: number; replied: number }> {
  return apiPost("/api/emails/sync", params ?? {});
}

export function processScheduledEmails(): Promise<{
  sent: number;
  failed: number;
}> {
  return apiPost("/api/emails/process-scheduled", {});
}

export function bulkRescheduleEmails(body: {
  emailMessageIds: string[];
  scheduledAt: string;
}): Promise<{ updated: number }> {
  return apiPost("/api/emails/bulk/reschedule", body);
}

export function bulkRetryEmails(body: {
  emailMessageIds: string[];
}): Promise<{ sent: number; failed: number }> {
  return apiPost("/api/emails/bulk/retry", body);
}

export function bulkDeleteEmails(body: {
  emailMessageIds: string[];
}): Promise<{ deleted: number }> {
  return apiPost("/api/emails/bulk/delete", body);
}
